function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "butter",
  transform: "translate(0 -32.952)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_74",
  "data-name": "Group 74"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_72",
  "data-name": "Group 72"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_71",
  "data-name": "Group 71"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_145",
  "data-name": "Path 145",
  d: "M0,141.6H207.134V343.784H0Z",
  fill: "#b4b4b4"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_146",
  "data-name": "Path 146",
  d: "M207.134,141.6,429.611,32.952V235.136L207.134,343.784Z",
  fill: "#444"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_147",
  "data-name": "Path 147",
  d: "M386.611,53.951V254.635L207.134,342.284v1.5L429.611,235.136V32.952Z",
  fill: "#b4b4b4"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_148",
  "data-name": "Path 148",
  d: "M222.477,32.952H429.611L207.134,141.6H0Z",
  fill: "#b4b4b4"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_73",
  "data-name": "Group 73"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_149",
  "data-name": "Path 149",
  d: "M497,399.724H238.275l25.8-116.555H471.2Z",
  fill: "#b4b4b4"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_150",
  "data-name": "Path 150",
  d: "M471.2,283.169h-40L457,399.724h40Z",
  fill: "#b4b4b4"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_151",
  "data-name": "Path 151",
  d: "M238.275,399.724H497v64.324H238.275Z",
  fill: "#b4b4b4"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_152",
  "data-name": "Path 152",
  d: "M457,399.724h40v64.324H457Z",
  fill: "#b4b4b4"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Path_153",
  "data-name": "Path 153",
  d: "M171.5,246a7.5,7.5,0,0,1-7.5-7.5v-59a7.5,7.5,0,0,1,15,0v59A7.5,7.5,0,0,1,171.5,246Z",
  fill: "#b4b4b4"
}));

function SvgButter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 497,
    height: 431.096,
    viewBox: "0 0 497 431.096",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButter);
export default __webpack_public_path__ + "static/media/butter.8d3d5822.svg";
export { ForwardRef as ReactComponent };